/**
 * Polyfills for older browsers
 */

// Declare the type for String.prototype.replaceAll
declare global {
  interface String {
    replaceAll(searchValue: string | RegExp, replaceValue: string): string;
    replaceAll(
      searchValue: string | RegExp,
      replacer: (substring: string, ...args: unknown[]) => string,
    ): string;
  }
}

// String.prototype.replaceAll polyfill
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (
    this: string,
    search: string | RegExp,
    replacement: string | ((substring: string, ...args: unknown[]) => string),
  ): string {
    if (search instanceof RegExp) {
      // Если это регулярное выражение, проверяем флаг 'g'
      if (!search.global) {
        throw new TypeError(
          'String.prototype.replaceAll called with a non-global RegExp argument',
        );
      }
      return this.replace(
        search,
        replacement as (substring: string, ...args: unknown[]) => string,
      );
    }

    // Если это строка, экранируем специальные символы regex и заменяем все вхождения
    const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return this.replace(
      new RegExp(escapedSearch, 'g'),
      replacement as (substring: string, ...args: unknown[]) => string,
    );
  };
}

export {};
